import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { useBudgetRange } from 'src/Redux/spotifyBudgetRangeApi'
import {
  setCampaignBudget,
  spotifyTotalPriceSelector,
} from 'src/Redux/spotifyCampaignMatchingProcess'

import { calculatePrice } from './helpers'

export const useBootstrapSpotifyCampaignBudget = (): void => {
  const dispatch = useAppDispatch()
  const totalPrice = useAppSelector(spotifyTotalPriceSelector)
  const { data: budgetRange, isLowReachError } = useBudgetRange()

  const rawMin = budgetRange?.min
  const rawMax = budgetRange?.max
  const absoluteCuratorsCount = budgetRange?.absoluteCuratorsCount ?? null

  useEffect(() => {
    if (!rawMin || !rawMax) {
      return
    }
    const min = Number(rawMin.toFixed(0))
    const max = Math.ceil(rawMax)
    const isWithinRange =
      typeof totalPrice === 'number' && totalPrice >= min && totalPrice <= max
    if (isWithinRange) {
      return
    }
    const price = calculatePrice(
      min,
      max,
      absoluteCuratorsCount,
      isLowReachError,
    )
    dispatch(setCampaignBudget(price))
  }, [
    rawMin,
    rawMax,
    absoluteCuratorsCount,
    isLowReachError,
    totalPrice,
    dispatch,
  ])
}
